import {
  Avatar,
  Group,
  Menu,
  Text,
  UnstyledButton,
} from "@mantine/core";
import React, { useState } from "react";
import { IconChevronDown, IconLogout } from "@tabler/icons-react";

interface UserProfileDetail {
  name: string;
  image: string;
  type: string;
}

function MenuUser({ name, image, type }: UserProfileDetail) {
  const [userMenuOpened, setUserMenuOpened] = useState(false);

  const signOut = () => {
    setTimeout(() => {
      window.location.href = "https://gradceremony.kpru.ac.th/";
    }, 100);
    window.localStorage.clear();
  };

  return (
    <Menu
      width={260}
      position="bottom-end"
      transitionProps={{ transition: "pop-top-right" }}
      onClose={() => setUserMenuOpened(false)}
      onOpen={() => setUserMenuOpened(true)}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton
          style={{
            borderRadius: 999,
            padding: "4px 8px 4px 4px",
            transition: "background-color 160ms ease",
            background: userMenuOpened
              ? "rgba(255,255,255,0.16)"
              : "transparent",
          }}
        >
          <Group gap="xs">
            <Avatar src={image} alt={name} radius="xl" size={36} />
            <Text size="sm" mr={2} visibleFrom="sm">
              {name}
              {type ? ` (${type})` : ""}
            </Text>
            <IconChevronDown size={16} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{name}</Menu.Label>
        <Menu.Item
          leftSection={<IconLogout size="0.9rem" stroke={1.5} />}
          component="button"
          onClick={signOut}
          color="red"
        >
          ออกจากระบบ
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default MenuUser;
